import { Asset } from '@/api/generatedApi';
import { ActionIconButton } from '@/components/IconButton';
import { AssetSelectionModal } from '@/components/modals/AssetSelectionModal';
import { useAddSupplementalAssets } from '@/hooks/api/assets/useAddSupplementalAssets';
import { useGetCurrentUser } from '@/hooks/api/users/useGetCurrentUser';
import { Add } from '@mui/icons-material';
import { Box, Tooltip } from '@mui/material';
import { useState } from 'react';

export const SupplementalAssetsAddButton = ({ asset }: { asset?: Asset }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { addSupplementalAssets, isAdding } = useAddSupplementalAssets();
  const { permissions } = useGetCurrentUser();

  const handleAssetSelect = (selectedAsset: Asset) => {
    if (!asset?.id) return;

    addSupplementalAssets(
      {
        assetId: asset.id,
        supplementalAssetIds: [selectedAsset.id],
      },
      {
        onSuccess: () => {
          setIsModalOpen(false);
        },
      }
    );
  };

  if (!asset || permissions.canOnlySearch) {
    return;
  }

  return (
    <Box>
      <ActionIconButton
        enableShadow={asset.hasSupplementalAssets}
        onClick={() => setIsModalOpen(true)}
        disabled={isAdding}
      >
        <Tooltip title='Add Supplemental Asset'>
          <Add sx={{ fontSize: '18px' }} />
        </Tooltip>
      </ActionIconButton>

      <AssetSelectionModal
        open={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onAssetSelect={handleAssetSelect}
        title='Select Supplemental Asset'
        description='Choose an asset to link as a supplemental asset to this asset.'
        getRowClassName={({ row }) => (row.id === asset.id ? 'disabled-row' : '')}
      />
    </Box>
  );
};
